module.exports = __webpack_public_path__ + "static/media/tablet.c2ec3383.png";